import { Controller } from 'stimulus'
import $ from 'jquery'

/**
 * 診療ガイドライン掲載ページ（#11114）の目次スムーススクロールとTOPへ戻るボタン。
 * 処方薬ページの medicine_controller と同じ役割だが、あちらは `.p-medicine` を
 * セレクタに直書きしていて流用できないため分けている。
 */
export default class extends Controller {
  static targets = ['topBtn']

  connect() {
    this.topBtn = $(this.topBtnTarget)
    this.onScroll = this.onScroll.bind(this)
    $(window).on('load scroll', this.onScroll)
    this.onScroll()
  }

  disconnect() {
    $(window).off('load scroll', this.onScroll)
  }

  // href をそのまま使うので、JSが動かなくてもアンカーには到達できる
  linkClick(event) {
    const hash = $(event.currentTarget).attr('href')
    const target = $(hash)
    if (target.length === 0) return

    event.preventDefault()
    $('body,html').animate({ scrollTop: Math.round(target.offset().top) - this.headerHeight() }, 500)
  }

  topBtnClick() {
    $('body,html').animate({ scrollTop: 0 }, 500)
  }

  onScroll() {
    this.topBtn.toggleClass('is-active', $(window).scrollTop() > 200)
  }

  // 固定ヘッダの下に見出しが隠れないよう高さ分ずらす
  headerHeight() {
    return $('.js-shared-header').outerHeight(true) ?? 0
  }
}
